// React
import { useContext } from "react";

// Context
import { mainContext } from "../context/mainContext";

// Services
import { translate } from "../services/languageUtils";

export function useTranslation() {
  const { language } = useContext(mainContext);

  return (keyPath) => translate(language, keyPath);
}
